<!--
Copyright 2022 Carnegie Mellon University. All Rights Reserved.
Released under a MIT (SEI)-style license. See LICENSE.md in the project root for license information.
-->

<div class="wall-container">
  <div class="top-row">
    <div class="toolbar-group">
      @if (exhibit) {
      <span class="move-inject-label">Move {{ exhibit.currentMove }}, Inject {{ exhibit.currentInject }}</span>
      }
      @if (showAdvanceButton && exhibit?.showAdvanceButton) {
      <button mat-flat-button class="advance-button" (click)="advanceExhibit()"
        [disabled]="isAdvancing"
        title="Advance the exhibit to the next move/inject for all participants">
        Advance
      </button>
      }
    </div>
    <div class="toolbar-group">
      <app-team-selector (changeTeam)="changeTeamRequest($event)"></app-team-selector>
      <button mat-icon-button (click)="gotoArchive('archive')" style="outline: none;" title="Archive">
        <mat-icon class="mdi-24px center-self" fontIcon="mdi-archive"></mat-icon>
      </button>
      @if (showAdminButton) {
      <button mat-icon-button (click)="gotoAdmin()" style="outline: none;" title="Administration">
        <mat-icon class="mdi-24px center-self" fontIcon="mdi-cog"></mat-icon>
      </button>
      }
    </div>
  </div>
  <section class="cards">
    @for (card of shownCardList; track card.id) {
    <mat-card appearance="outlined" [ngClass]="'card ' + statusClass(card.status)">
      @if (statusIcon(card.status)) {
      <div class="card-status" role="img" [attr.aria-label]="'Status: ' + card.status">
        <mat-icon class="mdi-18px" [fontIcon]="statusIcon(card.status)" aria-hidden="true"></mat-icon>
      </div>
      } @else {
      <!-- keeps titles level with the cards that do show a status -->
      <div class="card-status card-status-none" aria-hidden="true"></div>
      }
      <div class="card-body">
        <h2 class="card-title" [title]="card.name">{{ card.name }}</h2>
        @if (card.datePosted.getFullYear() > 1970) {
        <div class="card-date" title="Simulated Date/Time">
          <mat-icon class="mdi-18px" fontIcon="mdi-calendar-clock-outline"></mat-icon>
          {{ card.datePosted.toLocaleString('en-US', {year: '2-digit', month: 'numeric', day: 'numeric', hour: 'numeric', minute: '2-digit', timeZoneName: 'short'}) }}
        </div>
        } @else {
        <!-- keeps descriptions level with the cards that do show a date -->
        <div class="card-date" aria-hidden="true"></div>
        }
        <p class="card-description" [title]="card.description || ''">{{ card.description }}</p>
      </div>
      <div class="card-footer">
        @if (card.datePosted.getFullYear() > 1970) {
        @if (card.unreadCount > 0) {
        <span class="card-unread"
          [title]="card.unreadCount + (card.unreadCount === 1 ? ' unread article on this card' : ' unread articles on this card')">{{ card.unreadCount }} unread</span>
        }
        <button mat-stroked-button class="details-button" title="Open this card's articles in the archive"
          (click)="gotoArchive(card.id)">Details</button>
        } @else {
        <span class="card-empty">No articles posted</span>
        }
      </div>
    </mat-card>
    }
  </section>
</div>
